export default "__VITE_ASSET__C4yj7AKU__"